import React from 'react';
import UtilityService from '../services/UtillityServices/UtilityService';

const useArchivioRendicontazioniSuperpartnerConfigTable = () => {
    const columns = [
        // CORREZIONE: Usiamo 'key' e 'label' e aggiungiamo un 'formatter' per la visualizzazione
        { 
            key: 'nome_superpartner', 
            label: 'Superpartner' 
        },
        { 
            key: 'mese', 
            label: 'Mese' 
        },
        { 
            key: 'anno', 
            label: 'Anno' 
        },
        { 
            key: 'totale_provvigioni', 
            label: 'Importo Liquidato',
            formatter: (value) => `€ ${parseFloat(value).toFixed(2)}`
        },
        { 
            key: 'data_liquidazione', 
            label: 'Data Liquidazione',
            formatter: (value) => UtilityService.formatDate(value)
        },
        {
            key: 'path_ricevuta_pagamento',
            label: 'Ricevuta',
            formatter: (value) => <a href={value} target="_blank" rel="noopener noreferrer">Scarica</a>
        }
    ];

    return columns;
};

export default useArchivioRendicontazioniSuperpartnerConfigTable;